module.exports = __webpack_public_path__ + "static/media/monster-07.5c2e9778.png";